import React from 'react';
import { IconCircleXFilled } from '../../icons/IconCircleXFilled';
import styles from './styles.scoped.css';
import { IconCircleCheckFilled } from '../../icons/IconCircleCheckFilled';
import { IconLeft } from '../../icons/IconLeft';
import PropTypes from 'prop-types';
import { IconCheckOrange } from '../../icons/IconCheckOrange';
import { Badge } from '@mantine/core';
import ButtonEvidence from '../../fragments/ButtonEvidence';
import IconDocDefault from '../../icons/IconDocDefault';
import { useDispatch, useSelector } from 'react-redux';
import { fetchRequestFile } from './actions';

// NOTE: You have to wrap this component with mantine card for better layout or
//  try to add padding at parent container especially for bottom and top
export default function HistoryLog({ history = [],
  permanentBlock = false,
  customBadgeText = null }) {

  const { dataRequestFile } = useSelector(({ historyLog }) => historyLog);
  const dispatch = useDispatch();
  const txtTitleLog = {
    block: 'NIK Diblokir',
    unblock: 'NIK Diaktifkan',
    unblock_request: 'Pengajuan Buka Blokir Diterima',
    unblock_rejected: 'NIK Batal Diaktifkan'
  };
  const iconLog = {
    block: <IconCircleXFilled />,
    unblock: <IconCircleCheckFilled />,
    unblock_request: <IconCheckOrange />,
    unblock_rejected: <IconCircleXFilled />
  };
  const renderCaption = (dataLog) => {
    if (dataLog.actionType === 'unblock_request') {
      return `Tanggal pengajuan: ${dataLog.dateTime}`;
    } else {
      return `Data diverifikasi oleh ${dataLog.verifiedBy}, ${dataLog.dateTime}`;
    }
  };
  const textChild = {
    block: 'Alasan Diblokir',
    unblock: 'Alasan Diaktifkan',
    unblock_request: 'Alasan Buka Blokir'
  };

  const badgeStyle = {
    unblock: { bg: '#D1FADF', c: '#12B76A' },
    block: { bg: '#FEE4E2', c: '#F04438' },
  };

  const badgeText = {
    block: 'Diblokir',
    unblock: 'Diaktivasi'
  };

  const renderButtonEvidence = (log) => {
    if ((!log.supportDocument) || (log.supportDocument === 'null')) return null;
    return (
      <ButtonEvidence onClick={() => dispatch(fetchRequestFile({ fileName: log.supportDocument }))}
        url={dataRequestFile?.url ? dataRequestFile.url : ''}>
        <IconDocDefault />
        Lihat Dokumen Pendukung
      </ButtonEvidence>
    );
  };
  return (
    <div>
      <div className={styles.connector} />
      {
        history.map((log, index) => (
          <div className={styles.root} key={index}>
            <div className={styles.item}>
              {iconLog[log.actionType] || null}
              <div className={styles.flexLog}>
                <span className={styles.title}>
                  {txtTitleLog[log.actionType]} &nbsp;
                  {['unblock', 'block'].includes(log.actionType) &&
                    <Badge bg={badgeStyle[log.actionType]?.bg || 'grey'} c={badgeStyle[log.actionType]?.c || 'white'} fw={500} fz={14}
                      tt="none">
                      {customBadgeText ? customBadgeText[log.actionType]
                        : badgeText[log.actionType] || '-'}
                    </Badge>}
                </span>
                <span className={styles.info}>
                  {permanentBlock ? 'Data diblokir permanen oleh Sistem'
                    : renderCaption(log)}
                </span>
              </div>
            </div>
            {(log.reason && log.actionType === 'block') && (
              <div className={styles.childLog}>
                <div className={styles.item}>
                  <IconLeft />
                  <div className={styles.flexLog}>
                    <span className={styles.title}>{textChild[log.actionType]}</span>
                    <span className={styles.info}>{log.reason}</span>
                    {renderButtonEvidence(log)}
                  </div>
                </div>
                <div className={styles.item}>
                  <IconLeft />
                  <div className={styles.flexLog}>
                    <span className={styles.title}>Keterangan Blokir MAP</span>
                    <span className={styles.info}>{log.reasonDetail}</span>
                  </div>
                </div>
              </div>
            )}
            {['unblock', 'unblock_request'].includes(log.actionType) && (log.reasonDetail) && (
              <div className={styles.childLog}>
                <div className={styles.item}>
                  <IconLeft />
                  <div className={styles.flexLog}>
                    <span className={styles.title}>{textChild[log.actionType]}</span>
                    {renderButtonEvidence(log)}
                    <span className={styles.info}>{log.reasonDetail}</span>
                  </div>
                </div>
              </div>
            )}
          </div>
        ))
      }
    </div>
  );
}
HistoryLog.propTypes = {
  customBadgeText: PropTypes.object,
  history: PropTypes.array,
  permanentBlock: PropTypes.bool
};
